
import React, { useEffect, useState } from 'react'

import { MdArrowRight } from 'react-icons/md';
import Popup from '../../../../../common/components/popup';
import FromAddress from './fromAddressBook.component';
import ToAddress from './toAddressBook.component';

export default function AddressBookComponent({
    selectedToAddressBookId,
    selectedToAddressBook,
    setSelectedToAddressBookId,
    setSelectedToAddressBook,
    selectedFromAddressBookId,
    selectedFromAddressBook,
    setSelectedFromAddressBookId,
    setSelectedFromAddressBook,
    addressbookId,
    addressBook }: any) {

    const [isOpenFromAddressPopup, setIsOpenFromAddressPopup] = useState(false);
    const [isOpenToAddressPopup, setIsOpenToAddressPopup] = useState(false);

    const [searchTerm, setSearchTerm] = useState('');
    const [searchToTerm, setSearchToTerm] = useState('');
    const [fromAddressData, setFromAddressData] = useState<any>();
    const [toAddressData, setToAddressData] = useState<any>();
    const handleOpenFromAddressPopup = () => {
        setIsOpenFromAddressPopup(true);
    };

    const handleCloseFromAddressPopup = () => {
        setSearchTerm('');
        setIsOpenFromAddressPopup(false);
    };

    const handleOpenToAddressPopup = () => {
        setIsOpenToAddressPopup(true);
    };

    const handleCloseToAddressPopup = () => {
        setSearchToTerm('')
        setIsOpenToAddressPopup(false);
    };

    const handleSearch = (event: any) => {
        setSearchTerm(event.target.value);
    };
    const handleToSearch = (event: any) => {
        setSearchToTerm(event.target.value);
    };
    useEffect(() => {
        setFromAddressData(addressBook)
        setToAddressData(addressBook)
    }, [addressBook]);
    //Search for From Address
    useEffect(() => {
        if (searchTerm != "") {
            const filterData = addressBook?.filter(
                (item: any) => {

                    return item["FirstName"].toLowerCase().includes(searchTerm.toLowerCase())

                }
            )

            setFromAddressData(filterData)
        }
        else {

            setFromAddressData(addressBook)
        }
    }, [searchTerm])

    //Search for To Address
    useEffect(() => {
        if (searchToTerm != "") {
            const filterData = addressBook?.filter(
                (item: any) => {

                    return item["FirstName"].toLowerCase().includes(searchToTerm.toLowerCase())

                }
            )
            setToAddressData(filterData)
        }
        else {
            setToAddressData(addressBook)
        }
    }, [searchToTerm])

    return (
        <>
            <div className="bg-white flex w-full items-start justify-between p-4 rounded-lg shadow-md">
                <div className="flex space-x-4 w-full">

                    {/* Pickup Address */}
                    <div className="p-1 flex flex-col w-1/2">
                        <div className="font-semibold text-base text-slate-800 min-h-[1.5rem]">Pickup Address <span className="text-red-500">*</span></div>
                        {selectedFromAddressBook === "no data" ?
                            <div className="relative group mt-1">
                                <div className=" w-full border border-gray-300 font-normal rounded-md px-4 py-3 bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500 shadow-sm transition-all">



                                    <div className="flex justify-center py-2">
                                        <div
                                            onClick={handleOpenFromAddressPopup}
                                            className="inline-flex items-center text-sm font-medium text-blue-600 hover:text-blue-950 cursor-pointer"
                                        >
                                            Add the pickup address
                                            <MdArrowRight className="text-base" />
                                        </div>
                                    </div>
                                </div>
                            </div> :
                            <div className="relative group mt-1">
                                <div className="h-44 w-full border border-gray-300 font-normal rounded-md px-4 py-3 bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500 shadow-sm transition-all">
                                    <div className="items-center mb-1">
                                        <h5 className="text-base font-semibold text-gray-900 capitalize">
                                            {`${selectedFromAddressBook?.FirstName}, ${selectedFromAddressBook?.LastName}`}
                                        </h5>
                                    </div>
                                    <p className="text-sm text-gray-700 leading-relaxed">
                                        {`${selectedFromAddressBook?.Address1}, ${selectedFromAddressBook?.Address2}, `}
                                        {`${selectedFromAddressBook?.City}, ${selectedFromAddressBook?.StateProvince?.Name}, `}
                                        {`${selectedFromAddressBook?.ZipPostalCode}.`}
                                    </p>
                                    <p className="text-sm text-gray-700 leading-relaxed">
                                        {`Phone no: ${selectedFromAddressBook?.PhoneNumber}`}
                                    </p>
                                    <div className="flex justify-end py-2">
                                        <div
                                            onClick={handleOpenFromAddressPopup}
                                            className="inline-flex items-center text-sm font-medium text-blue-600 hover:text-blue-950 cursor-pointer"
                                        >
                                            Change the pickup address
                                            <MdArrowRight className="text-base ml-1" />
                                        </div>
                                    </div>
                                </div>
                            </div>}
                    </div>

                    {/* Drop Address */}
                    <div className="p-1 flex flex-col w-1/2">
                        <div className="font-semibold text-base text-slate-800 min-h-[1.5rem]">Drop Address <span className="text-red-500">*</span></div>
                        {selectedToAddressBook === "no data" ?
                            <div className="relative group mt-1">
                                <div className=" w-full border border-gray-300 font-normal rounded-md px-4 py-3 bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500 shadow-sm transition-all">



                                    <div className="flex justify-center py-2">
                                        <div
                                            onClick={handleOpenToAddressPopup}
                                            className="inline-flex items-center text-sm font-medium text-blue-600 hover:text-blue-950 cursor-pointer"
                                        >
                                            Add the drop address
                                            <MdArrowRight className="text-base" />
                                        </div>
                                    </div>
                                </div>
                            </div> :
                            <div className="relative group mt-1">
                                <div className="h-44 w-full border border-gray-300 font-normal rounded-md px-4 py-3 bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500 shadow-sm transition-all">
                                    <div className="flex items-center justify-between mb-1">
                                        <h5 className="text-base font-semibold text-gray-900 capitalize">
                                            {`${selectedToAddressBook?.FirstName}, ${selectedToAddressBook?.LastName}`}
                                        </h5>

                                    </div>
                                    <p className="text-sm text-gray-700 leading-relaxed">
                                        {`${selectedToAddressBook?.Address1}, ${selectedToAddressBook?.Address2}, `}
                                        {`${selectedToAddressBook?.City}, ${selectedToAddressBook?.StateProvince?.Name}, `}
                                        {`${selectedToAddressBook?.ZipPostalCode}.`}
                                    </p>
                                    <p className="text-sm text-gray-700 leading-relaxed">
                                        {`Phone no: ${selectedToAddressBook?.PhoneNumber}`}
                                    </p>
                                    <div className="flex justify-end py-2">
                                        <div
                                            onClick={handleOpenToAddressPopup}
                                            className="inline-flex items-center text-sm font-medium text-blue-600 hover:text-blue-950 cursor-pointer"
                                        >
                                            Change the drop address
                                            <MdArrowRight className="text-base" />
                                        </div>
                                    </div>
                                </div>
                            </div>}
                    </div>

                </div>
            </div>
            {isOpenFromAddressPopup && (
                <Popup onClose={handleCloseFromAddressPopup}>
                    <div className="flex justify-between items-center border-b p-2">
                        <h2 className="text-2xl font-bold">Manage From Address</h2>
                        <div className="relative w-64">
                            <input
                                type="text"
                                name="search"
                                placeholder="Search the name..."
                                value={searchTerm}
                                onChange={(e) => handleSearch(e)}
                                className="bg-slate-100 text-slate-800 border border-slate-300 h-8 px-2 w-full font-light focus:outline-none focus:ring-2 focus:ring-blue-400 rounded"
                            />
                            <button type="submit" className="absolute right-2 top-1.5">
                                <svg className="h-4 w-4 text-slate-600" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56.966 56.966">
                                    <path d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z" />
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div className='py-4'>
                        <FromAddress
                            addressBook={fromAddressData}
                            addressbookId={addressbookId}
                            selectedFromAddressBookId={selectedFromAddressBookId}
                            setSelectedFromAddressBookId={setSelectedFromAddressBookId}
                            selectedFromAddressBook={selectedFromAddressBook}
                            setSelectedFromAddressBook={setSelectedFromAddressBook}
                            onClose={handleCloseFromAddressPopup}
                        />
                    </div>
                </Popup>

            )}
            {isOpenToAddressPopup && (
                <Popup onClose={handleCloseToAddressPopup}>
                    <div className="flex justify-between items-center border-b p-2">
                        <h2 className="text-2xl font-bold mb-4">Manage To Address</h2>
                        <div className="relative w-64">
                            <input
                                type="text"
                                name="search"
                                placeholder="Search the name..."
                                value={searchToTerm}
                                onChange={(e) => handleToSearch(e)}
                                className="bg-slate-100 text-slate-800 border border-slate-300 h-8 px-2 w-full font-light focus:outline-none focus:ring-2 focus:ring-blue-400 rounded"
                            />
                            <button type="submit" className="absolute right-2 top-1.5">
                                <svg className="h-4 w-4 text-slate-600" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56.966 56.966">
                                    <path d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z" />
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div className='py-4'>
                        <ToAddress
                            addressBook={toAddressData}
                            addressbookId={addressbookId}
                            selectedToAddressBookId={selectedToAddressBookId}
                            setSelectedToAddressBookId={setSelectedToAddressBookId}
                            selectedToAddressBook={selectedToAddressBook}
                            setSelectedToAddressBook={setSelectedToAddressBook}
                            onClose={handleCloseToAddressPopup}
                        />
                    </div>
                </Popup>
            )} </>
    )
}